import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
const Home = () => {
  return <div className="w-full" data-id="element-400">
      <Hero data-id="element-401" />
      <Services data-id="element-402" />
      <About data-id="element-403" />
      <Pricing data-id="element-404" />
      <FAQ data-id="element-405" />
      <Contact data-id="element-406" />
    </div>;
};
export default Home;